import { type JSONData } from "../../base_classes/dto.d";
import { Dto } from "../../base_classes/dto";
import { type IApiKeyDto } from "./dto.gen.d";

/// ///////////////////////////////////////////////////////////////////////////////////////////////////
/// WARNING! THIS FILE IS AUTOMATICALLY GENERATED, ANY CHANGES WILL BE LOST ON NEXT GENERATION
/// ///////////////////////////////////////////////////////////////////////////////////////////////////

// ENUMS

export class ApiKeyDto extends Dto implements IApiKeyDto {
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////
  _path = "/api_key/{id}";
  _reference = "/ApiKey/{id}";

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////

  _kind = "ApiKey";

  publicKey = "";

  secretKey = "";

  userId = "";

  /// ///////////////////////////////////////
  /// ///////////// METHODS /////////////////
  /// ///////////////////////////////////////

  static FromJSON(data: unknown): ApiKeyDto {
    // Create a new instance of the class
    const obj = new ApiKeyDto();
    obj.set(data as JSONData);
    return obj;
  }

  static FromJSONArray(data: unknown[]): ApiKeyDto[] {
    return data.map((item) => ApiKeyDto.FromJSON(item));
  }

  override set(data: JSONData): void {
    super.set(data);

    // Implement variables here
    if (data._kind !== undefined && data._kind !== null) {
      this._kind = (data._kind as string) ?? this._kind;
    }
    if (data.publicKey !== undefined && data.publicKey !== null) {
      this.publicKey = (data.publicKey as string) ?? this.publicKey;
    }
    if (data.secretKey !== undefined && data.secretKey !== null) {
      this.secretKey = (data.secretKey as string) ?? this.secretKey;
    }
    if (data.userId !== undefined && data.userId !== null) {
      this.userId = (data.userId as string) ?? this.userId;
    }
  }
}
